import { marketingAgentPromptSchema } from "@redotech/redo-model/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as z from "zod/v4";

/**
 * RPC schema for retrieving all AI options for SMS templates.
 *
 * This endpoint returns Strategy prompts that are enabled,
 * providing all the AI configuration options needed for SMS template creation.
 */
export const getSmsTemplateAiOptions = {
  name: "getSmsTemplateAiOptions" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    strategyPrompts: z.array(marketingAgentPromptSchema),
  }),
};
